import { handleActions } from 'redux-actions'
import get from 'lodash.get'

import {
  requestNewsAction,
  requestNewsFailAction,
  requestNewsSuccessAction
} from '../actions/news'

const INITIAL_STATE = {
  loading: false, list: [], error: ''
}

const reducer = handleActions({
  [requestNewsAction]: (state, action) => ({
    error: '',
    loading: true,
    list: []
  }),
  [requestNewsFailAction]: (state, action) => ({
    error: `Error - ${action.error}`,
    loading: false,
    list: []
  }),
  [requestNewsSuccessAction]: (state, action) => ({
    error: '',
    loading: false,
    list: get(action, 'payload', [])
  })
}, INITIAL_STATE)

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/news.js